import { FC, useState, useEffect } from "react";
import { Modal, message, Tabs } from "antd";
import {
  BlogCategoryModel,
  CreateBlogCategoryModel,
  UpdatedBlogCategoryModel,
} from "states/blog-category/blog-category.models";
import {
  addBlogCategory,
  getBlogCategoryByIdApi,
  updateBlogCategory,
} from "states/blog-category/blog-category.api";
import { BlogCategoryInformationTab } from "./components/blog-category-information-tab";
import { CustomTheme } from "shared/components/custom-theme/custom-theme";
import { Seo } from "shared/components/seo/seo";
import { SeoModel } from "shared/models/seo-model";
import { RootState } from "app.store";
import { shallowEqual, useSelector } from "react-redux";
import { LanguageSelector } from "shared/components/language-selector";

interface IBlogCategoryModalProps {
  model: BlogCategoryModel;
  onModal: boolean;
  closeModal: () => void;
  onSuccess: () => void;
  isUpdate: boolean;
}
export const BlogCategoryModalComponent: FC<IBlogCategoryModalProps> = (
  props
) => {
  const { model, onModal, closeModal, onSuccess, isUpdate } = props;
  const clientLanguages = useSelector(
    (state: RootState) => state.localization.clientLanguages,
    shallowEqual
  );
  const [currentLanguage, setCurrentLanguage] = useState<string>();

  const [blogCateModel, setBlogCateModel] = useState<BlogCategoryModel>(
    {} as BlogCategoryModel
  );
  const [isLoading, setLoading] = useState(false);
  const handleCloseModal = () => closeModal();
  const onSubmit = async () => {
    setLoading(true);
    try {
      if (isUpdate) {
        let payload: UpdatedBlogCategoryModel = {
          ...blogCateModel,
          id: blogCateModel.id,
          name: blogCateModel.name,
          slug: blogCateModel.slug,
          avatar: blogCateModel.avatar,
          description: blogCateModel.description,
          seoFields: blogCateModel.seoFields,
          customizeTheme: blogCateModel.customizeTheme,
        };
        await updateBlogCategory(payload, currentLanguage);
      } else {
        let payload: CreateBlogCategoryModel = {
          ...blogCateModel,
          name: blogCateModel.name,
          slug: blogCateModel.slug,
          avatar: blogCateModel.avatar,
          seoFields: blogCateModel.seoFields,
          customizeTheme: blogCateModel.customizeTheme,
          description: blogCateModel.description,
        };
        await addBlogCategory(payload, currentLanguage);
      }
      handleCloseModal();
      setLoading(false);
      onSuccess();
      message.success("Cập nhật thành công");
    } catch (error) {
      message.error(error?.response?.data?.error?.message ?? "Lỗi hệ thống");
      setLoading(false);
    }
  };
  const onReset = () => {
    setBlogCateModel({} as BlogCategoryModel);
  };
  const onFill = () => {
    setBlogCateModel(model);
  };

  useEffect(() => {
    if (!isUpdate) {
      onReset();
    } else {
      onFill();
    }
    //Lúc mở modal lên thì trả về ngôn ngữ mặc định
    if (onModal && clientLanguages.length > 0 && currentLanguage) {
      setCurrentLanguage(clientLanguages.find((m) => m.isDefault)?.langCode);
    }
  }, [onModal]);

  useEffect(() => {
    if (clientLanguages.length > 0 && !currentLanguage) {
      setCurrentLanguage(clientLanguages.find((m) => m.isDefault)?.langCode);
    }
  }, [clientLanguages]);

  return (
    <Modal
      width="1000px"
      title={
        <div
          style={{
            width: "100%",
            cursor: "move",
          }}
        >
          {isUpdate ? "Cập nhật thông tin" : "Thêm danh mục"}
        </div>
      }
      confirmLoading={isLoading}
      centered={true}
      visible={onModal}
      onOk={onSubmit}
      onCancel={handleCloseModal}
      okText={"Lưu"}
      cancelText={"Hủy"}
    >
      {isUpdate && (
        <div className="mb-4">
          <LanguageSelector
            onChange={async (value) => {
              const res = await getBlogCategoryByIdApi(blogCateModel.id, value);
              if (!res.data.name) {
                Modal.confirm({
                  title: "Thông báo",
                  content:
                    "Nội dung chưa được khởi tạo cho ngôn ngữ này, bạn có muốn khởi tạo?",
                  onOk: () => {
                    setCurrentLanguage(value);
                  },
                });
                return;
              } else {
                setCurrentLanguage(value);
                setBlogCateModel(res.data);
              }
            }}
            selectedCode={currentLanguage}
          />
        </div>
      )}
      <Tabs type="card">
        <Tabs.TabPane tab="Thông tin danh mục" key="1">
          <BlogCategoryInformationTab
            model={blogCateModel}
            onChange={setBlogCateModel}
            isUpdateMode={isUpdate}
          />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Giao diện" key="giao-dien">
          <CustomTheme
            onChange={(changedModel) => {
              setBlogCateModel({
                ...blogCateModel,
                customizeTheme: changedModel,
              });
            }}
            model={model.customizeTheme ?? {}}
          />
        </Tabs.TabPane>
        <Tabs.TabPane tab="SEO" key="seo">
          <Seo
            model={blogCateModel.seoFields ?? ({} as SeoModel)}
            slug={blogCateModel.slug}
            onChange={(seoFields, slug) => {
              setBlogCateModel({ ...blogCateModel, slug, seoFields });
            }}
          />
        </Tabs.TabPane>
      </Tabs>
    </Modal>
  );
};
